export class KreditlinieRuledProduktlinien {
    static START = 'Start';
    static STANDARD = 'Standard';
    static SPEZIAL = 'Spezial';
}
